module.exports = __webpack_public_path__ + "img/tmf-logo.1c2f0968.png";